import React, { type ReactNode } from "react";
import { WorkspaceGrid, WorkspaceInner, WorkspaceMain, WorkspaceWrap } from "../styles";

interface Props {
	detectionPanel?: ReactNode;
	glossaryPanel?: ReactNode;
	drawer?: ReactNode;
	detectionOpen?: boolean;
	children: ReactNode;
}

export default function WorkspaceShell({ detectionPanel, glossaryPanel, drawer, detectionOpen, children }: Props) {
	return (
		<WorkspaceWrap>
			<WorkspaceInner>
				<WorkspaceGrid detectionOpen={detectionOpen}>
					{detectionOpen && detectionPanel}
					<WorkspaceMain>{children}</WorkspaceMain>
				</WorkspaceGrid>
				{glossaryPanel}
				{drawer}
			</WorkspaceInner>
		</WorkspaceWrap>
	);
}
